import React from "react";
import { connect } from "react-redux";

import { HubContextMenu } from "../../components";
import { setIsOpenDialog } from "../../redux";

const MENU_ITEMS = [
  { id: "edit", label: "Edit", icon: "Edit" },
  { id: "delete", label: "Delete", icon: "Trash2", color: "redError" },
];

const FinancialsContextMenu = ({
  item,
  _setIsOpenDialog = () => {},
  ...rest
}) => {
  const id = item?.id;

  const onSelect = (selected) => {
    switch (selected?.id) {
      case "edit":
        _setIsOpenDialog("financial-period", id);
        break;
      case "delete":
        _setIsOpenDialog("delete-financial-period", id);
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id={`financial-period-${id}`}
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{ sx: { padding: 0 } }}
      {...rest}
    />
  );
};

const mapDispatchToProps = { _setIsOpenDialog: setIsOpenDialog };

export default connect(null, mapDispatchToProps)(FinancialsContextMenu);
